var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarginaliaShopping(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 182,
    viewBox: "0 0 186 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M172.725 13.8545V149.165H13.2559V13.8545H172.725ZM173.247 13.333H12.7344V149.687H173.247V13.333Z",
    fill: "#C4ECFE"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M173.247 110.001H12.7344V110.489H173.247V110.001Z",
    fill: "#C4ECFE"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M173.247 90.4688H12.7344V90.9566H173.247V90.4688Z",
    fill: "#C4ECFE"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M173.247 110.001H12.7344V110.489H173.247V110.001Z",
    fill: "#C4ECFE"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M173.247 129.516H12.7344V130.003H173.247V129.516Z",
    fill: "#C4ECFE"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M173.247 70.9531H12.7344V71.441H173.247V70.9531Z",
    fill: "#C4ECFE"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M173.247 51.4219H12.7344V51.9098H173.247V51.4219Z",
    fill: "#C4ECFE"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M173.247 31.9062H12.7344V32.3941H173.247V31.9062Z",
    fill: "#C4ECFE"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.249 65.772C173.249 61.2633 166.755 60.5736 165.813 64.9981C164.484 71.2396 162.818 78.4905 154.474 81.3169C145.12 84.4797 147.492 96.2729 130.282 101C113.088 105.711 128.515 143.21 98.7207 149.704H173.232L173.249 65.772Z",
    fill: "url(#paint0_linear_6942_105631)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8129 93.3115H49.4941V114.677H65.8129V93.3115Z",
    fill: "#F9D0B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2341 115.098H49.0742V92.8906H66.2341V115.098ZM49.9154 114.256H65.393V93.7318H49.9154V114.256Z",
    fill: "#F9D0B5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9478 93.3115H28.582V114.677H49.9478V93.3115Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.369 115.098H28.1621V92.8906H50.369V115.098ZM29.0033 114.256H49.5279V93.7318H29.0033V114.256Z",
    fill: "#F9D0B5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4936 103.573H28.582V104.414H49.4936V103.573Z",
    fill: "#F9D0B5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6869 93.3115H38.8457V114.677H39.6869V93.3115Z",
    fill: "#F9D0B5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7687 114.93H42.1589C41.9233 114.93 41.7383 115.115 41.7383 115.35V149.014C41.7383 149.25 41.9233 149.435 42.1589 149.435H80.7687C81.0042 149.435 81.1893 149.25 81.1893 149.014V115.35C81.1893 115.115 81.0042 114.93 80.7687 114.93Z",
    fill: "#F9D5FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8648 115.351H22.0879V149.014H42.8648V115.351Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8655 149.435H22.0886C21.853 149.435 21.668 149.25 21.668 149.014V115.35C21.668 115.115 21.853 114.93 22.0886 114.93H42.8655C43.101 114.93 43.2861 115.115 43.2861 115.35V149.014C43.2861 149.25 43.101 149.435 42.8655 149.435ZM22.5091 148.593H42.4449V115.771H22.5091V148.593Z",
    fill: "#F9D5FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8932 64.0225H64.668V92.656H79.8932V64.0225Z",
    fill: "#F9D5FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8939 93.0762H64.6686C64.4331 93.0762 64.248 92.8912 64.248 92.6556V64.0221C64.248 63.7866 64.4331 63.6016 64.6686 63.6016H79.8939C80.1294 63.6016 80.3144 63.7866 80.3144 64.0221V92.6556C80.3144 92.8912 80.1294 93.0762 79.8939 93.0762ZM65.0892 92.2351H79.4733V64.4427H65.0892V92.2351Z",
    fill: "#F9D5FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2757 64.0225H39.8555V92.656H65.2757V64.0225Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2744 93.0762H39.8542C39.6187 93.0762 39.4336 92.8912 39.4336 92.6556V64.0221C39.4336 63.7866 39.6187 63.6016 39.8542 63.6016H65.2744C65.5099 63.6016 65.695 63.7866 65.695 64.0221V92.6556C65.695 92.8912 65.5099 93.0762 65.2744 93.0762ZM40.2748 92.2351H64.8538V64.4427H40.2748V92.2351Z",
    fill: "#F9D5FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M148.417 92.7061H104.895V149.401H148.417V92.7061Z",
    fill: "#F9D0B5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M143.419 99.1162H109.873V143.009H143.419V99.1162Z",
    fill: "#F9D0B5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M143.42 143.429H109.874C109.638 143.429 109.453 143.244 109.453 143.008V99.1159C109.453 98.8804 109.638 98.6953 109.874 98.6953H143.42C143.655 98.6953 143.84 98.8804 143.84 99.1159V143.008C143.84 143.244 143.655 143.429 143.42 143.429ZM110.294 142.588H142.999V99.5365H110.294V142.588Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M143.419 99.1162V104.045L130.414 121.054L126.646 125.983L113.642 143.009H109.873V138.079L122.878 121.054L126.646 116.125L139.651 99.1162H143.419Z",
    fill: "#F9D0B5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M113.642 143.429H109.874C109.638 143.429 109.453 143.244 109.453 143.008V138.079C109.453 137.995 109.487 137.894 109.537 137.827L122.542 120.801L139.315 98.8635C139.399 98.7626 139.517 98.6953 139.651 98.6953H143.42C143.655 98.6953 143.84 98.8804 143.84 99.1159V104.045C143.84 104.129 143.807 104.23 143.756 104.298L126.983 126.235L113.979 143.261C113.895 143.362 113.777 143.429 113.642 143.429ZM110.294 142.588H113.44L126.31 125.731L142.999 103.911V99.5365H139.853L123.215 121.306L110.294 138.214V142.588Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M143.419 138.079V143.009H139.651L126.646 125.983L122.878 121.054L109.873 104.045V99.1162H113.642L143.419 138.079Z",
    fill: "#F9D0B5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M143.42 143.429H139.651C139.517 143.429 139.399 143.362 139.315 143.261L126.31 126.235L109.537 104.298C109.487 104.23 109.453 104.129 109.453 104.045V99.1159C109.453 98.8804 109.638 98.6953 109.874 98.6953H113.642C113.777 98.6953 113.895 98.7626 113.979 98.8635L143.756 137.827C143.807 137.894 143.84 137.995 143.84 138.079V143.008C143.84 143.244 143.655 143.429 143.42 143.429ZM139.853 142.588H142.999V138.214L113.44 99.5365H110.294V103.911L126.983 125.731L139.853 142.588Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M106.475 93.127H50.6211V148.981H106.475V93.127Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M106.896 149.401H50.2012V92.7061H106.896V149.401ZM51.0423 148.56H106.055V93.5472H51.0423V148.56Z",
    fill: "#F9D0B5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M100.486 99.1162H56.5938V143.009H100.486V99.1162Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M100.487 143.429H56.5944C56.3589 143.429 56.1738 143.244 56.1738 143.008V99.1159C56.1738 98.8804 56.3589 98.6953 56.5944 98.6953H100.487C100.722 98.6953 100.907 98.8804 100.907 99.1159V143.008C100.907 143.244 100.722 143.429 100.487 143.429ZM57.015 142.588H100.066V99.5365H57.015V142.588Z",
    fill: "#F9D0B5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M100.486 99.1162V104.045L83.4776 121.054L78.5483 125.983L61.523 143.009H56.5938V138.079L73.6191 121.054L78.5483 116.125L95.5568 99.1162H100.486Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5237 143.429H56.5944C56.3589 143.429 56.1738 143.244 56.1738 143.008V138.079C56.1738 137.961 56.2243 137.86 56.2916 137.776L95.2547 98.8131C95.3388 98.729 95.4397 98.6953 95.5575 98.6953H100.487C100.722 98.6953 100.907 98.8804 100.907 99.1159V104.045C100.907 104.163 100.857 104.264 100.79 104.348L61.8265 143.311C61.7424 143.378 61.6415 143.429 61.5237 143.429ZM57.015 142.588H61.3555L100.066 103.877V99.5365H95.7257L57.015 138.247V142.588Z",
    fill: "#F9D0B5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M100.486 138.079V143.009H95.5568L78.5483 125.983L73.6191 121.054L56.5938 104.045V99.1162H61.523L100.486 138.079Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M100.487 143.429H95.5575C95.4397 143.429 95.3388 143.378 95.2547 143.311L78.2462 126.286L73.3169 121.356L56.2916 104.348C56.2075 104.264 56.1738 104.163 56.1738 104.045V99.1159C56.1738 98.8804 56.3589 98.6953 56.5944 98.6953H61.5237C61.6415 98.6953 61.7424 98.7458 61.8265 98.8131L100.79 137.776C100.874 137.86 100.907 137.961 100.907 138.079V143.008C100.907 143.244 100.722 143.429 100.487 143.429ZM95.7257 142.588H100.066V138.247L61.3555 99.5365H57.015V103.877L73.9226 120.768L78.8518 125.697L95.7257 142.588Z",
    fill: "#F9D0B5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M153.227 122.012H132.736V148.828H153.227V122.012Z",
    fill: "#F9D5FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M154.068 149.67H131.895V121.171H154.068V149.67ZM133.577 147.987H152.385V122.853H133.577V147.987Z",
    fill: "#F9D5FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M133.291 122.012H106.475V148.828H133.291V122.012Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M134.132 149.67H105.633V121.171H134.132V149.67ZM107.315 147.987H132.449V122.853H107.315V147.987Z",
    fill: "#F9D5FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M164.028 113.18H151.596V128.926H164.028V113.18Z",
    fill: "#F9D5FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M152.74 114.021H138.676V128.085H152.74V114.021Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M153.581 128.926H137.834V113.18H153.581V128.926ZM139.516 127.244H151.898V114.862H139.516V127.244Z",
    fill: "#F9D5FF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M136.928 104.078H123.688V121.406H136.928V104.078Z",
    fill: "#F9D0B5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M137.768 122.248H122.846V103.237H137.768V122.248ZM124.528 120.565H136.086V104.92H124.528V120.565Z",
    fill: "#F9D0B5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M124.039 104.079H106.711V121.407H124.039V104.079Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M124.46 121.828H106.291V103.658H124.46V121.828ZM107.132 120.986H123.619V104.499H107.132V120.986Z",
    fill: "#F9D0B5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M123.449 103.475L106.117 120.808L107.307 121.997L124.639 104.665L123.449 103.475Z",
    fill: "#F9D0B5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M107.307 103.487L106.117 104.677L123.449 122.009L124.639 120.819L107.307 103.487Z",
    fill: "#F9D0B5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M173.078 127.581H155.918V149.788H173.078V127.581Z",
    fill: "#F9D0B5"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M156.776 128.002H135.41V149.368H156.776V128.002Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M157.197 149.788H134.99V127.581H157.197V149.788ZM135.831 148.947H156.356V128.422H135.831V148.947Z",
    fill: "#F9D0B5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M156.339 138.265H135.41V139.106H156.339V138.265Z",
    fill: "#F9D0B5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M146.515 128.002H145.674V149.368H146.515V128.002Z",
    fill: "#F9D0B5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M127.892 133.504H115.812V149.318H127.892V133.504Z",
    fill: "#F9D0B5"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M128.143 149.57H115.576V133.269H128.143V149.57ZM116.064 149.066H127.655V133.74H116.064V149.066Z",
    fill: "#F9D0B5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M126.611 135.203H117.105V147.636H126.611V135.203Z",
    fill: "#F9D0B5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M126.611 148.056H117.106C116.871 148.056 116.686 147.871 116.686 147.635V135.203C116.686 134.967 116.871 134.782 117.106 134.782H126.611C126.847 134.782 127.032 134.967 127.032 135.203V147.635C127.032 147.871 126.847 148.056 126.611 148.056ZM117.527 147.215H126.191V135.623H117.527V147.215Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M117.105 147.636V146.239L120.79 141.428L121.85 140.031L125.534 135.203H126.611V136.599L122.926 141.428L121.85 142.824L118.165 147.636H117.105Z",
    fill: "#F9D0B5"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M118.166 148.056H117.106C116.871 148.056 116.686 147.871 116.686 147.635V146.239C116.686 146.155 116.719 146.054 116.77 145.987L120.454 141.175L121.514 139.779L125.198 134.95C125.282 134.85 125.4 134.782 125.535 134.782H126.611C126.847 134.782 127.032 134.967 127.032 135.203V136.599C127.032 136.683 126.998 136.784 126.948 136.852L123.264 141.68L122.187 143.076L118.502 147.888C118.418 147.989 118.301 148.056 118.166 148.056ZM117.527 147.215H117.964L121.514 142.571L122.591 141.175L126.191 136.465V135.623H125.737L121.127 141.68L117.527 146.374V147.215Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M117.105 136.599V135.203H118.165L121.85 140.031L122.926 141.428L126.611 146.239V147.636H125.534L117.105 136.599Z",
    fill: "#F9D0B5"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M126.611 148.056H125.535C125.4 148.056 125.282 147.989 125.198 147.888L116.77 136.852C116.719 136.784 116.686 136.683 116.686 136.599V135.203C116.686 134.967 116.871 134.782 117.106 134.782H118.166C118.301 134.782 118.418 134.85 118.502 134.95L122.187 139.779L123.264 141.175L126.948 145.987C126.998 146.054 127.032 146.155 127.032 146.239V147.635C127.032 147.871 126.847 148.056 126.611 148.056ZM125.737 147.215H126.191V146.374L122.591 141.68L121.514 140.283L117.947 135.623H117.51V136.465L125.737 147.215Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M143.384 133.504H127.57V149.318H143.384V133.504Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M143.385 149.738H127.571C127.335 149.738 127.15 149.553 127.15 149.318V133.504C127.15 133.268 127.335 133.083 127.571 133.083H143.385C143.621 133.083 143.806 133.268 143.806 133.504V149.318C143.806 149.553 143.621 149.738 143.385 149.738ZM127.992 148.897H142.964V133.924H127.992V148.897Z",
    fill: "#F9D0B5"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M141.702 135.203H129.27V147.636H141.702V135.203Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M141.703 148.056H129.27C129.035 148.056 128.85 147.871 128.85 147.635V135.203C128.85 134.967 129.035 134.782 129.27 134.782H141.703C141.938 134.782 142.123 134.967 142.123 135.203V147.635C142.123 147.871 141.938 148.056 141.703 148.056ZM129.691 147.215H141.282V135.623H129.691V147.215Z",
    fill: "#F9D0B5"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M129.27 147.636V146.239L134.081 141.428L135.477 140.031L140.306 135.203H141.702V136.599L136.874 141.428L135.477 142.824L130.666 147.636H129.27Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M130.667 148.056H129.27C129.035 148.056 128.85 147.871 128.85 147.635V146.239C128.85 146.121 128.9 146.02 128.967 145.936L140.004 134.9C140.088 134.816 140.189 134.782 140.306 134.782H141.703C141.938 134.782 142.123 134.967 142.123 135.203V136.599C142.123 136.717 142.073 136.818 142.006 136.902L130.969 147.938C130.885 148.005 130.784 148.056 130.667 148.056ZM129.691 147.215H130.498L141.282 136.431V135.623H140.475L129.691 146.407V147.215Z",
    fill: "#F9D0B5"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M129.27 136.599V135.203H130.666L135.477 140.031L136.874 141.428L141.702 146.239V147.636H140.306L129.27 136.599Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M141.703 148.056H140.306C140.189 148.056 140.088 148.005 140.004 147.938L128.967 136.902C128.883 136.818 128.85 136.717 128.85 136.599V135.203C128.85 134.967 129.035 134.782 129.27 134.782H130.667C130.784 134.782 130.885 134.833 130.969 134.9L137.177 141.125L142.006 145.936C142.09 146.02 142.123 146.121 142.123 146.239V147.635C142.123 147.871 141.938 148.056 141.703 148.056ZM140.475 147.215H141.282V146.407L135.175 140.317L130.481 135.607H129.674V136.414L140.475 147.215Z",
    fill: "#F9D0B5"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M105.634 148.98H38.1719V149.67H105.634V148.98Z",
    fill: "#2B2B2B"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M102.757 82.2597C106.492 75.3453 103.413 73.8984 109.773 67.2868C116.132 60.692 112.094 46.022 113.743 38.5019C114.281 35.9952 116.603 32.1931 117.747 28.5929C119.177 24.0674 113.995 20.3662 110.16 23.1421C109.066 23.9328 107.922 25.0095 106.744 26.49C106.358 26.9779 105.87 27.3984 105.314 27.7013C103.565 28.6939 101.798 29.6528 99.359 31.0323C90.8968 35.827 92.6296 45.6519 88.7434 50.4466C84.8572 55.2413 72.1554 53.1215 64.9887 64.0567C49.4774 87.7105 86.3881 112.626 102.757 82.2597Z",
    fill: "url(#paint1_linear_6942_105631)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M72.912 31.9911C72.912 31.9911 71.6839 49.7903 73.871 53.4073C74.8467 55.0392 76.344 56.1664 78.0095 56.7215L78.7666 56.9739L104.776 63.5182C108.981 64.8977 113.524 62.6266 114.903 58.4039C116.283 54.198 114.012 49.6557 109.789 48.2762L83.78 41.7318L86.068 55.7794L84.9913 30.2246",
    fill: "url(#paint2_linear_6942_105631)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0085 30.2073L84.0496 26.8427C83.1579 23.764 79.9446 21.9807 76.866 22.8723C74.1742 23.6462 72.4582 26.2202 72.6769 28.9119L72.9124 31.9906L85.0085 30.2073Z",
    fill: "#FDC068"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M60.834 123.359L78.5491 98.4605L65.8305 93.3125L60.834 123.359Z",
    fill: "#2B2B2B"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M59.723 77.9524C51.0421 92.8916 42.5463 129.079 41.1836 131.165L58.4781 129.651L76.3278 89.7288L118.908 82.8817L98.7534 70.4492L74.5613 69.8267C68.488 69.5743 62.7849 72.7035 59.723 77.9524Z",
    fill: "url(#paint3_linear_6942_105631)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M34.034 138.298L54.2557 134.934C55.8203 134.126 56.1736 133.621 57.2335 131.704L58.4784 129.668L41.1839 131.182L32.604 136.246C31.359 137.121 32.5871 138.887 34.034 138.298Z",
    fill: "#2B2B2B"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6699 70.9538C100.066 62.9795 105.248 64.1235 104.171 58.4708C103.094 52.8182 106.728 45.6345 112.583 46.5094C117.108 47.1823 117.445 47.0309 119.346 47.3169C125.369 48.2085 129.928 54.4669 127.152 60.2373C127.152 60.2373 124.931 62.3066 124.645 64.1235C124.359 65.9404 128.145 69.221 127.186 74.7055L98.6699 70.9538Z",
    fill: "url(#paint4_linear_6942_105631)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M121.095 47.7543C121.633 48.3431 121.549 50.1769 119.244 50.9171C116.956 51.6742 112.935 53.2219 111.455 53.1883C109.975 53.1546 107.905 51.5564 108.343 49.2684L111.135 46.7617L119.951 47.3842L121.095 47.7543Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6701 71.1898C98.6532 71.1898 98.6364 71.1898 98.6364 71.1898C98.5187 71.173 98.4345 71.0552 98.4514 70.9206C99.1579 66.8998 100.823 65.1502 102.153 63.737C102.59 63.2828 102.994 62.8453 103.313 62.3911C103.381 62.2902 103.532 62.2565 103.633 62.3406C103.734 62.4079 103.768 62.5593 103.683 62.6603C103.347 63.1482 102.926 63.5856 102.472 64.0566C101.177 65.4193 99.5785 67.1353 98.8888 71.0047C98.8719 71.1057 98.7878 71.1898 98.6701 71.1898Z",
    fill: "#2B2B2B"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2313 134.127L98.7885 91.126L88.7617 94.5075L96.2313 134.127Z",
    fill: "#2B2B2B"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M110.413 72.502L83.7646 76.7078C78.482 77.3976 74.7977 81.4184 72.7284 86.3476C66.3691 101.556 81.5944 138.046 81.6785 138.769L96.2307 134.126L93.3203 94.507L125.218 90.2507L110.413 72.502Z",
    fill: "url(#paint5_linear_6942_105631)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6222 148.242L96.0627 140.15C97.2572 139.645 97.846 138.282 97.3749 137.071L96.2309 134.144L81.6787 138.787L74.4446 146.155C73.2838 146.997 74.2932 148.797 75.6222 148.242Z",
    fill: "#2B2B2B"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M127.304 73.8305C126.934 78.1373 124.36 84.648 116.234 83.6554L109.707 82.6628C102.304 81.7544 98.3676 75.0923 98.7546 70.4658L127.304 73.8305Z",
    fill: "url(#paint6_linear_6942_105631)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M114.484 72.3164L117.529 85.3546L123.3 81.0982L119.06 72.8548L114.484 72.3164Z",
    fill: "#2B2B2B"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M113.323 51.0017L105.904 48.2258C105.904 48.2258 107.452 46.3584 111.422 46.3584L113.323 51.0017Z",
    fill: "#2B2B2B"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M113.426 101.185C113.863 101.084 121.854 98.796 128.701 96.1548C133.715 94.2201 136.793 89.1394 136.154 83.7895C135.01 74.1497 131.528 59.3451 131.326 58.6721L130.855 57.1244C130.703 56.6701 130.569 56.1991 130.417 55.7449C129.004 51.4885 124.294 49.0828 120.071 50.5632C116.353 51.8755 114.2 55.6439 114.788 59.4124C114.872 59.9507 114.973 60.4722 115.074 61.0106L115.377 62.6088C115.579 63.6687 115.815 64.7286 116.05 65.7884C116.521 67.9082 120.878 81.1146 120.878 81.1146C120.878 81.1146 108.547 89.0721 108.328 89.1899",
    fill: "url(#paint7_linear_6942_105631)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M108.344 89.1729C107.688 89.5934 107.032 90.014 106.376 90.4514L105.097 91.3094C104.677 91.6122 104.239 91.8982 103.836 92.2011C101.211 94.1021 100.622 97.7696 102.524 100.411C103.987 102.447 106.527 103.237 108.815 102.632C109.32 102.497 109.808 102.346 110.296 102.194L111.776 101.74C112.332 101.572 112.887 101.387 113.442 101.202",
    fill: "#FDC068"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M110.514 39.9657L115.746 40.2517C118.455 40.4031 120.776 38.317 120.911 35.6084L121.197 29.2996C121.382 25.6321 118.101 21.258 113.761 21.0225C109.421 20.787 105.719 24.118 105.484 28.4585L105.232 34.1111C105.08 37.1898 107.435 39.8143 110.514 39.9657Z",
    fill: "#FDC068"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M106.595 31.672C107.087 31.672 107.486 31.2728 107.486 30.7803C107.486 30.2879 107.087 29.8887 106.595 29.8887C106.102 29.8887 105.703 30.2879 105.703 30.7803C105.703 31.2728 106.102 31.672 106.595 31.672Z",
    fill: "#2B2B2B"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M112.852 51.1694L118.774 49.0496C119.447 48.8141 119.918 48.1916 119.968 47.485L120.893 35.8432C120.523 33.8917 112.398 33.5889 112.398 33.5889L109.975 48.5449C109.723 50.1936 111.237 51.5731 112.852 51.1694Z",
    fill: "#FDC068"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M108.681 33.5383C108.631 33.5383 108.597 33.5215 108.564 33.5047L107.84 33.0336C107.655 32.8822 107.554 32.6635 107.537 32.4448C107.52 32.2093 107.605 31.9906 107.756 31.8224L108.917 30.5438C109.001 30.4428 109.152 30.4428 109.236 30.5269C109.337 30.6111 109.337 30.7625 109.253 30.8466L108.092 32.1252C108.025 32.1925 107.992 32.2934 107.992 32.3944C107.992 32.4953 108.042 32.5962 108.126 32.6467L108.816 33.1009C108.917 33.1682 108.95 33.3196 108.883 33.4206C108.833 33.5047 108.765 33.5383 108.681 33.5383Z",
    fill: "#2B2B2B"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M108.715 36.2305C108.681 36.2305 108.648 36.2305 108.631 36.2305C108.059 36.1968 107.453 35.7762 107.369 34.9014C107.352 34.7668 107.453 34.6659 107.571 34.6491C107.706 34.6323 107.806 34.7332 107.823 34.851C107.874 35.4734 108.311 35.7258 108.648 35.7594C109.068 35.7931 109.556 35.5071 109.724 34.8173C109.758 34.6995 109.876 34.6154 110.01 34.6491C110.128 34.6827 110.212 34.8005 110.179 34.9351C109.977 35.8435 109.321 36.2305 108.715 36.2305Z",
    fill: "#2B2B2B"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M111.372 39.9988L114.737 39.7969L110.834 43.2793L111.372 39.9988Z",
    fill: "#2B2B2B"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M111.692 31.9239C112.185 31.9239 112.584 31.5247 112.584 31.0323C112.584 30.5398 112.185 30.1406 111.692 30.1406C111.2 30.1406 110.801 30.5398 110.801 31.0323C110.801 31.5247 111.2 31.9239 111.692 31.9239Z",
    fill: "#2B2B2B"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M115.023 21.0387C114.401 23.2931 107.032 27.398 105.35 27.6503C105.35 27.6503 105.652 20.5004 115.023 21.0387Z",
    fill: "url(#paint8_linear_6942_105631)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M115.021 21.0391C115.021 21.0391 116.149 39.0906 116.149 43.2797C116.149 47.4687 120.052 46.3584 124.022 49.2688C129.153 45.9546 130.078 36.2643 125.2 33.3202C121.078 30.8303 122.289 29.5517 120.422 25.6487C118.554 21.7456 115.021 21.0391 115.021 21.0391Z",
    fill: "url(#paint9_linear_6942_105631)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M118.168 72.9892C118.067 72.9892 117.983 72.9219 117.949 72.821L115.577 64.6784C115.543 64.5607 115.611 64.4261 115.728 64.3925C115.846 64.3588 115.981 64.4261 116.014 64.5439L118.387 72.6864C118.42 72.8042 118.353 72.9388 118.235 72.9724C118.218 72.9892 118.185 72.9892 118.168 72.9892Z",
    fill: "#2B2B2B"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7825 49.1509C85.6647 49.1509 85.5638 49.0499 85.547 48.9321L85.2441 42.1691C85.2441 42.0345 85.3451 41.9336 85.4628 41.9336C85.5974 41.9336 85.6984 42.0345 85.6984 42.1523L86.0012 48.9153C86.018 49.0331 85.9171 49.134 85.7825 49.1509Z",
    fill: "#2B2B2B"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M123.686 87.1551C123.602 87.1551 123.518 87.1046 123.484 87.0205L120.692 81.1996C120.641 81.0818 120.692 80.9472 120.793 80.8968C120.91 80.8463 121.045 80.8967 121.095 80.9977L123.888 86.8186C123.939 86.9364 123.888 87.0709 123.787 87.1214C123.754 87.1382 123.72 87.1551 123.686 87.1551Z",
    fill: "#2B2B2B"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4664 101.421C71.3487 101.421 71.2477 101.337 71.2309 101.219L70.2552 91.7815C69.5822 85.3381 73.8554 79.4499 80.181 78.0535L96.3988 74.487C96.5165 74.4533 96.6511 74.5374 96.6679 74.6552C96.7016 74.773 96.6175 74.9076 96.4997 74.9244L80.2819 78.4909C74.1918 79.8368 70.0701 85.5063 70.7262 91.7142L71.702 101.152C71.7188 101.287 71.6179 101.388 71.5001 101.404C71.4833 101.421 71.4664 101.421 71.4664 101.421Z",
    fill: "#2B2B2B"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3207 94.7419C93.2029 94.7419 93.102 94.6578 93.0852 94.54L92.7655 91.1585C92.7487 91.0239 92.8496 90.923 92.9674 90.9061C93.102 90.8893 93.2029 90.9903 93.2197 91.108L93.5394 94.4895C93.5562 94.6241 93.4553 94.7251 93.3375 94.7419H93.3207Z",
    fill: "#2B2B2B"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M53.363 149.688C44.3793 149.688 40.2744 136.515 29.6924 137.793C26.5128 138.18 22.963 131.67 21.5162 129.213C19.1105 125.142 12.7344 126.791 12.7344 131.485V149.688H53.363Z",
    fill: "url(#paint10_linear_6942_105631)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M49.494 53.3559C43.4039 53.3559 37.9026 47.8546 32.5864 42.5384C28.1282 38.0802 23.9055 33.8575 19.666 32.9827L20.0025 31.334C24.7299 32.2929 29.1208 36.6838 33.7809 41.3439C38.8616 46.4246 44.1105 51.6735 49.494 51.6735V53.3559Z",
    fill: "#F9D5FF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M141.721 32.4612V30.7789C146.246 30.7789 150.654 25.5973 154.557 21.0213C157.989 16.9837 160.967 13.4844 163.894 13.4844V15.1667C161.741 15.1667 158.746 18.6996 155.836 22.098C151.697 26.96 147.02 32.4612 141.721 32.4612Z",
    fill: "#F9D5FF"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6917 76.4879C28.0727 76.4879 28.3815 76.1791 28.3815 75.7982C28.3815 75.4172 28.0727 75.1084 27.6917 75.1084C27.3108 75.1084 27.002 75.4172 27.002 75.7982C27.002 76.1791 27.3108 76.4879 27.6917 76.4879Z",
    fill: "#BFD9FF"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M113.088 127.564C113.469 127.564 113.778 127.255 113.778 126.874C113.778 126.493 113.469 126.185 113.088 126.185C112.707 126.185 112.398 126.493 112.398 126.874C112.398 127.255 112.707 127.564 113.088 127.564Z",
    fill: "#BFD9FF"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M153.43 46.3912C153.811 46.3912 154.12 46.0824 154.12 45.7015C154.12 45.3205 153.811 45.0117 153.43 45.0117C153.049 45.0117 152.74 45.3205 152.74 45.7015C152.74 46.0824 153.049 46.3912 153.43 46.3912Z",
    fill: "#BFD9FF"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0081 22.7711C67.3891 22.7711 67.6979 22.4623 67.6979 22.0814C67.6979 21.7004 67.3891 21.3916 67.0081 21.3916C66.6272 21.3916 66.3184 21.7004 66.3184 22.0814C66.3184 22.4623 66.6272 22.7711 67.0081 22.7711Z",
    fill: "#BFD9FF"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2269 28.1041C24.6078 28.1041 24.9166 27.7953 24.9166 27.4144C24.9166 27.0334 24.6078 26.7246 24.2269 26.7246C23.8459 26.7246 23.5371 27.0334 23.5371 27.4144C23.5371 27.7953 23.8459 28.1041 24.2269 28.1041Z",
    fill: "#BFD9FF"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M158.764 81.3001C159.117 81.3001 159.404 81.0138 159.404 80.6608C159.404 80.3077 159.117 80.0215 158.764 80.0215C158.411 80.0215 158.125 80.3077 158.125 80.6608C158.125 81.0138 158.411 81.3001 158.764 81.3001Z",
    fill: "#BFD9FF"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2741 99.7551C45.6271 99.7551 45.9133 99.4689 45.9133 99.1158C45.9133 98.7628 45.6271 98.4766 45.2741 98.4766C44.921 98.4766 44.6348 98.7628 44.6348 99.1158C44.6348 99.4689 44.921 99.7551 45.2741 99.7551Z",
    fill: "#BFD9FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6942_105631",
    x1: 135.985,
    y1: 79.1274,
    x2: 135.985,
    y2: 135.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0DDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6942_105631",
    x1: 81.5222,
    y1: 31.6675,
    x2: 99.4699,
    y2: 78.3265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9774AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#47A6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5011,
    stopColor: "#A7A7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5908,
    stopColor: "#E89AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE7D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6942_105631",
    x1: 93.9375,
    y1: 73.2926,
    x2: 93.9375,
    y2: 42.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4092,
    stopColor: "#F5943B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4989,
    stopColor: "#F05052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.599,
    stopColor: "#ECE674"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1EEC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6942_105631",
    x1: 80.0458,
    y1: 136.165,
    x2: 80.0458,
    y2: 69.5354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#7AAEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5908,
    stopColor: "#B8C1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D4D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6942_105631",
    x1: 113.327,
    y1: 73.1508,
    x2: 113.327,
    y2: 43.3705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4092,
    stopColor: "#F5943B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4989,
    stopColor: "#F05052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.599,
    stopColor: "#ECE674"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1EEC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6942_105631",
    x1: 98.1967,
    y1: 136.165,
    x2: 98.1967,
    y2: 69.5357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#7AAEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5908,
    stopColor: "#B8C1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D4D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6942_105631",
    x1: 113.016,
    y1: 136.165,
    x2: 113.016,
    y2: 69.5352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#7AAEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5908,
    stopColor: "#B8C1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D4D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6942_105631",
    x1: 122.283,
    y1: 71.7586,
    x2: 122.283,
    y2: 44.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4092,
    stopColor: "#F5943B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4989,
    stopColor: "#F05052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.599,
    stopColor: "#ECE674"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1EEC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6942_105631",
    x1: 110.186,
    y1: 17.0429,
    x2: 110.186,
    y2: 67.0365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9774AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#47A6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5011,
    stopColor: "#A7A7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5908,
    stopColor: "#E89AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE7D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6942_105631",
    x1: 121.714,
    y1: 17.0433,
    x2: 121.714,
    y2: 67.0368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9774AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#47A6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5011,
    stopColor: "#A7A7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5908,
    stopColor: "#E89AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE7D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6942_105631",
    x1: 33.0487,
    y1: 130.969,
    x2: 33.0487,
    y2: 148.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarginaliaShopping);
export default __webpack_public_path__ + "static/media/marginalia-shopping.1ef2e188.svg";
export { ForwardRef as ReactComponent };